(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/game-guide/winplan.js') >= 0) return;  svs.modules.push('/modules/matchen/views/game-guide/winplan.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.winplan = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"panel panel-default\">\n    <div class=\"panel-body\">\n        <h3 class=\"margin-bottom-1\"><strong>Vinstplan</strong></h3>\n        <p>Återbetalningen på Oddset Matchen är 72,5%, varav 2,5% avsätts till rullpottsfond</p>\n    </div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-matchen-winplan'] = svs.matchen.templates.winplan;
})(svs, Handlebars);


 })(window);